module.exports = __webpack_public_path__ + "static/media/sea-xs.7d901ad3.jpg";